export default {
  title: 'Our services',
  images:[
    {
      title: 'Advice and consultancy',
      img: require('@/assets/iconos/ico_4.svg')
    },
    {
      title: 'Audit',
      img: require('@/assets/iconos/ico_5.svg')
    },
    {
      title: 'Sworn translation',
      img: require('@/assets/iconos/ico_6.svg')
    },
    {
      title: 'Seminars',
      img: require('@/assets/iconos/ico_7.svg')
    },
    {
      title: 'Recruitment',
      img: require('@/assets/iconos/ico_8.svg')
    },
    {
      title: 'Outsourcing',
      img: require('@/assets/iconos/ico_9.svg')
    },
    {
      title: 'Technology and systems',
      img: require('@/assets/iconos/ico_10.svg')
    },
    {
      title: 'Taxs and legal',
      img: require('@/assets/iconos/ico_11.svg')
    }
  ],
  services:[
    {
      title: 'Advice and consultancy',
      image: require('@/assets/images/asesorias.jpg'),
      list: [
        '- Financial and business.',
        '- Legal.',
        '- Corporate Tax.',
        '- Corporate labor.',
        '- Risks.',
        '- Internal control.',
        '- Incorporation of Companies.',
        '- Technology and systems.'
      ],
      position: 'left'
    },
    {
      title: 'Audit',
      image: require('@/assets/images/auditoria.jpg'),
      list: [
        '- Financial Statements Audit.',
        '- Special audit.',
        '- Specific item audit.',
        '- Forensic audit.',
        '- Systems Audit -PED-.',
        '- Internal Audit.',
        '- Due Diligence.',
        '- Financial Diagnoses and their strategies.'
      ],
      position: 'right'
    },
    {
      title: 'Taxes',
      image: require('@/assets/images/impuesto.jpg'),
      list: [
        '- Transfer Pricing Studies.',
        '- Analysis of Compliance with Formal Duties.',
        '- Business Strategies.',
        '- Tax Planning.',
        '- Fiscal Defense.',
        '- Recovery of Tax Credit.',
        '- Produce Designs as an Analysis Tool.',
        '- Fiscal diagnoses.',
      ],
      position: 'left'
    },
    {
      title: 'Outsourcing',
      image: require('@/assets/images/outsourcing.jpg'),
      list: [
        '- Accounting.',
        '- Human Resources.',
        '- Payroll.',
        '- Internal Audit.',
      ],
      position: 'right'
    },
    {
      title: 'Other services',
      image: require('@/assets/images/otros_servicios.jpg'),
      list: [
        '- Sworn Traslation: English-Spanish, Spanish-English.',
        '- Mercantile Affairs, Legal Business and Notaries.',
        '- Other legal matters.',
      ],
      position: 'left'
    },
    {
      title: 'Seminars',
      image: require('@/assets/images/seminarios.jpg'),
      list: [
        '- Tax Update current legislation ((VAT, ISO, I.T. , Tax Code etc.).',
        '- Money Laundering or Other Assets Law.',
        '- Conversion of financial statements from generally accepted accounting principles (GAAP) to IFRS (international financial reporting standards).',
        '- How to prepare the cash flow statement.',
        '- Internal Control Base on Risks.',
        '- How to prepare an Audit of financial statements based on International Auditing standards.',
        '- Organization of an Internal Audit Department.',
        '- Strengthening of an adequate internal control.',
        '- Domain extinction law and its implications as a going concern.',
        '- Application of transfer pricing studies.',
        '- Others.',
      ],
      position: 'right'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/text/en/services.js